export const AboutState = {
  loading: true,
  error: {
    status: null,
    message: null,
  },
  data: {},
};
